import { c as _c } from "react/compiler-runtime";
import { Input as InputPrimitive } from "@base-ui/react/input";
import * as React from "react";
import { cn } from "@/lib/utils";
function Input(t0) {
  const $ = _c(10);
  let className;
  let props;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = type;
  } else {
    className = $[1];
    props = $[2];
    type = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("dark:bg-input/30 border-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 disabled:bg-input/50 dark:disabled:bg-input/80 h-8 rounded-none border bg-transparent px-2.5 py-1 text-xs transition-colors file:h-6 file:text-xs file:font-medium focus-visible:ring-1 aria-invalid:ring-1 md:text-xs file:text-foreground placeholder:text-muted-foreground w-full min-w-0 outline-none file:inline-flex file:border-0 file:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== t1 || $[8] !== type) {
    t2 = <InputPrimitive type={type} data-slot="input" className={t1} {...props} />;
    $[6] = props;
    $[7] = t1;
    $[8] = type;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export { Input };